import * as React from 'react'

const DrawOuterWall = props =>
  <svg width={32} height={32} viewBox="0 0 32 32" {...props}>
    <g stroke={props.color} fill="none" fillRule="evenodd" strokeLinejoin="round">
      <path d="M6.5 11.5h19M16 7v4.5M16 16v4.5M20.5 11.5V16M20.5 20.5V25M11.5 11.5V16M11.5 20.5V25M6.5 16h19M6.5 20.5h19"/>
      <rect x={6.5} y={7} width={19} height={18} rx={1}/>
    </g>
  </svg>
export default DrawOuterWall